<template>
  <div class="p-page">
    <div class="m-overview">
      <h3>数据总览</h3>
      <div class="m-search">
        <el-form inline>
          <el-form-item label="月份">
            <el-date-picker
              v-model="overviewQuery.month"
              type="month"
              placeholder="选择月"
              @change="getStudentOverviewData"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="机构筛选">
            <el-select
              v-model="overviewQuery.agencyUuid"
              placeholder="请选择机构"
              clearable
              @change="getStudentOverviewData"
            >
              <el-option v-for="item in agencyOpts" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="等级筛选">
            <el-select
              v-model="overviewQuery.level"
              placeholder="请选择等级"
              clearable
              @change="getStudentOverviewData"
            >
              <el-option v-for="item in levelOpts" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getStudentOverviewData">查询</el-button>
            <el-button type="primary" @click="userDataExport">下载表格</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="m-data">
        <h4>数据看板</h4>
        <ul class="m-list f-flex">
          <li class="m-item f-text-center">
            <p class="w1">学员总数</p>
            <p class="w2">{{ overviewData.totalStudent || "--" }}</p>
          </li>
          <li class="m-item f-text-center">
            <p class="w1">完成率</p>
            <p class="w2">{{ overviewData.completeRate || "--" }}%</p>
          </li>
          <li class="m-item f-text-center">
            <p class="w1">通过率</p>
            <p class="w2">{{ overviewData.passRate || "--" }}%</p>
          </li>
        </ul>
      </div>

      <div class="m-charts f-flex">
        <div class="u-complete f-relative" ref="complete" v-loading="chart.isLoadingComplete">
          <div class="t-name f-absolute-inlineflex">完成率</div>
        </div>
        <div class="u-pass f-relative" ref="pass" v-loading="chart.isLoadingPass">
          <div class="t-name f-absolute-inlineflex">通过率</div>
        </div>
      </div>
    </div>

    <div class="m-user">
      <h3>用户行为数据</h3>
      <div class="m-search">
        <el-form inline>
          <el-form-item label="">
            <el-select v-model="trendQuery.dayType" placeholder="选择类型" clearable @change="handleChangeDayType">
              <el-option v-for="item in dayTypeOpt" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker
              v-if="trendQuery.dayType == 1"
              v-model="trendQuery.dateRange"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
            <el-date-picker
              v-if="trendQuery.dayType == 2"
              v-model="trendQuery.dateRange"
              type="monthrange"
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份"
            >
            </el-date-picker>

            <template v-if="trendQuery.dayType == 3">
              <el-date-picker key="start" v-model="trendQuery.dateRange[0]" type="year"> </el-date-picker>
              <span style="margin: 0 4px">至</span>
              <el-date-picker key="end" v-model="trendQuery.dateRange[1]" type="year"> </el-date-picker>
            </template>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="trendQuery.agencyUuid" placeholder="请选择机构" clearable @change="getStudentTrendData">
              <el-option v-for="item in agencyOpts" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" @click="getStudentTrendData">查询</el-button>
            <el-button type="primary" @click="userTrendExport">下载表格</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="u-user" ref="user" v-loading="chart.isLoadingUser">{{ trendQuery }}</div>
    </div>
  </div>
</template>

<script>
import { getStudentOverviewData, getStudentTrendData, userTrendExport, userDataExport } from "@/api/analysis.js";
import { getSchoolList } from "@/api/school.js";
import dayjs from "dayjs";

export default {
  data() {
    return {
      overviewQuery: {
        month: "",
        agencyUuid: "",
        level: "",
      },
      agencyOpts: [], // 机构列表
      levelOpts: [
        { label: "普通", value: 1 },
        { label: "初级", value: 2 },
        { label: "中级", value: 3 },
        { label: "高级", value: 4 },
      ], // 等级列表
      overviewData: {
        totalStudent: 0,
        completeRate: 0,
        passRate: 0,
      },
      chart: {
        complete: null,
        isLoadingComplete: false,
        pass: null,
        isLoadingPass: false,
        user: null,
        isLoadingUser: false,
      },
      trendQuery: {
        dayType: 1,
        dateRange: ["", ""],
        agencyUuid: "",
      },
      dayTypeOpt: [
        { label: "按天", value: 1 },
        { label: "按月", value: 2 },
      ],
    };
  },
  mounted() {
    this.chart.complete = this.$echarts.init(this.$refs.complete);
    this.chart.pass = this.$echarts.init(this.$refs.pass);
    this.chart.user = this.$echarts.init(this.$refs.user);

    this.getSchoolList();
    this.getStudentOverviewData();
    this.getStudentTrendData();
  },
  methods: {
    // 获取机构列表
    async getSchoolList() {
      const res = await getSchoolList({ page_index: 1, page_size: 999, status: 1 });
      this.agencyOpts = res.data.map((v) => ({
        label: v.name,
        value: v.uuid,
      }));
    },
    // 获取学员数据预览
    async getStudentOverviewData() {
      const body = {
        catalogue: this.overviewQuery.level,
        schoole_uuid: this.overviewQuery.agencyUuid,
      };
      if (this.overviewQuery.month) {
        const specifiedDate = dayjs(this.overviewQuery.month);
        body.start_date = specifiedDate.startOf("month").format("YYYY-MM-DD");
        body.end_date = specifiedDate.endOf("month").format("YYYY-MM-DD");
      }
      const res = await getStudentOverviewData(body);
      this.overviewData = {
        totalStudent: res.total,
        completeRate: res.per1,
        passRate: res.per2,
      };
      // const res = { total: 1028, per1: "39.2", per2: "57.7" };
      // 完成图表
      this.chart.complete.setOption(
        {
          tooltip: {
            trigger: "item",
            formatter: (val) => {
              return `${val.value}%`;
            },
          },
          legend: {
            orient: "vertical",
            right: "right",
            bottom: "center",
          },
          series: [
            {
              name: "完成率",
              type: "pie",
              radius: "50%",
              data: [
                { value: Number(res.per1), name: "完成" },
                { value: 100 - Number(res.per1), name: "未完成" },
              ],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
        },
        true,
      );
      // 通过图表
      this.chart.pass.setOption(
        {
          tooltip: {
            trigger: "item",
            formatter: (val) => {
              return `${val.value}%`;
            },
          },
          legend: {
            orient: "vertical",
            right: "right",
            bottom: "center",
          },
          series: [
            {
              name: "通过率",
              type: "pie",
              radius: "50%",
              data: [
                { value: Number(res.per2), name: "通过" },
                { value: 100 - Number(res.per2), name: "未通过" },
              ],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
        },
        true,
      );
    },
    // 用户数据导出
    async userDataExport() {
      const body = {
        catalogue: this.overviewQuery.level,
        schoole_uuid: this.overviewQuery.agencyUuid,
        export: 1,
      };
      if (this.overviewQuery.month) {
        const specifiedDate = dayjs(this.overviewQuery.month);
        body.start_date = specifiedDate.startOf("month").format("YYYY-MM-DD");
        body.end_date = specifiedDate.endOf("month").format("YYYY-MM-DD");
      }
      const res = await userDataExport(body);
      if (!res) return;
      window.open(res);
    },
    // 获取用户趋势数据
    async getStudentTrendData() {
      const body = {
        type: this.trendQuery.dayType,
        schoole_uuid: this.trendQuery.agencyUuid,
        start_date: this.trendQuery.dateRange[0] ? dayjs(this.trendQuery.dateRange[0]).format("YYYY-MM-DD") : "",
        end_date: this.trendQuery.dateRange[1] ? dayjs(this.trendQuery.dateRange[1]).format("YYYY-MM-DD") : "",
      };

      const res = await getStudentTrendData(body);
      // 图表
      this.chart.user.setOption(
        {
          title: {
            text: "用户行为数据",
          },
          tooltip: {
            trigger: "axis",
          },
          legend: {
            data: ["用户总数", "学习课节", "考试用户"],
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true,
          },
          toolbox: {
            feature: {
              saveAsImage: {},
            },
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: res.map((v) => v.day),
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              name: "用户总数",
              type: "line",
              data: res.map((v) => v.user_count),
            },
            {
              name: "学习课节",
              type: "line",
              data: res.map((v) => v.learn_count),
            },
            {
              name: "考试用户",
              type: "line",
              data: res.map((v) => v.exam_count),
            },
          ],
        },
        true,
      );
    },
    // 用户趋势导出
    async userTrendExport() {
      const body = {
        type: this.trendQuery.dayType,
        schoole_uuid: this.trendQuery.agencyUuid,
        start_date: this.trendQuery.dateRange[0] ? dayjs(this.trendQuery.dateRange[0]).format("YYYY-MM-DD") : "",
        end_date: this.trendQuery.dateRange[1] ? dayjs(this.trendQuery.dateRange[1]).format("YYYY-MM-DD") : "",
      };
      const res = await userTrendExport(body);
      if (!res) return;
      window.open(res);
    },
    // 修改日期类型
    handleChangeDayType() {
      if (this.trendQuery.dayType == 2) {
        this.trendQuery.dateRange = [
          dayjs().startOf("year").format("YYYY-MM-DD"),
          dayjs().endOf("year").format("YYYY-MM-DD"),
        ];
      } else {
        this.trendQuery.dateRange = ["", ""];
      }
      this.getStudentTrendData();
    },
  },
};
</script>

<style lang="less" scoped="scoped">
.p-page {
  padding: 10px;
}
.m-overview,
.m-user {
  margin-bottom: 20px;
  .m-search {
    margin: 10px 0;
  }
  .m-data {
    background-color: #ececec;
    padding: 20px;
    display: inline-block;
    h4 {
      margin-bottom: 10px;
    }
    .m-list {
      background-color: #fff;

      .m-item {
        width: 300px;
        padding: 20px;
        .w1 {
          font-size: 30px;
          margin-bottom: 10px;
        }
        .w2 {
          font-size: 20px;
        }
      }
    }
  }
  .m-charts {
    .u-complete,
    .u-pass {
      width: 400px;
      height: 400px;
      margin-right: 100px;
      .t-name {
        bottom: 40px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
  .u-user {
    width: 1000px;
    height: 400px;
  }
}
</style>
